import React from "react";
import { CSSProperties, useEffect, useState } from "react";
import ChatBot, { Button } from "react-chatbotify";
import { Params } from "react-chatbotify/dist/types/Params";
import { ChatbotResponse } from "../../api/responsePayload/ChatbotResponse";
import { ragMemberSecretKey } from "../../api/util/contants";
import CustomButton, { ButtonType } from "../../components/button/CustomButton";
import { RagChat } from "../../api/ChatBotApiCall";

interface MyChatBotProps {
  chatWindowStyle: CSSProperties;
}

const MyChatBot: React.FC<MyChatBotProps> = ({ chatWindowStyle }) => {
  const [thread, setThread] = useState<string>("1");

  const changeThread = () => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const length = 4; // or however long you want the thread ID
    let result = "";

    for (let i = 0; i < length; i++) {
      result += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    }

    setThread(result);
    localStorage.removeItem("example_smart_conversation");
  };

  useEffect(() => {
    changeThread();
  }, []);

  async function fetchData(message: string): Promise<ChatbotResponse | null> {
    const response = await RagChat(
      message,
      thread,
      "303",
      "10",
      ragMemberSecretKey
    );
    return response;
  }

  const flow = {
    start: {
      message: "Hey! How can I help you!",
      path: "loop",
    },
    loop: {
      message: async (param: Params) => {
        const result = await fetchData(param.userInput);
        const reply = result?.reply || "No title returned";
        const contexts = result?.retrieved_context || [];
        const question = result?.rewrite_question;
        const image_urls = result?.image_urls;

        if (question) {
          const questionDisplay = "❓ Question:\n" + question;
          await param.injectMessage(questionDisplay, "bot");
        }

        if (image_urls) {
          for (const url of image_urls) {
            await param.injectMessage(
              <div style={{ margin: "16px" }}>
                <img
                  src={url}
                  alt="context image"
                  style={{ maxWidth: "200px", borderRadius: "8px" }}
                />
              </div>,
              "bot"
            );
          }
        }

        const nonEmptyContexts = contexts.filter(
          (ctx) => ctx && ctx.trim() !== ""
        );
        if (nonEmptyContexts.length > 0) {
          const contextText =
            "📚 Retrieved Contexts:\n" +
            nonEmptyContexts
              .map((ctx: string, idx: number) => `${idx + 1}. ${ctx}`)
              .join("\n");

          await param.injectMessage(contextText, "bot");
        }
        return reply;
      },
      path: "loop",
    },
  };
  return (
    <>
      <ChatBot
        styles={{
          chatWindowStyle: chatWindowStyle,
        }}
        key={thread}
        settings={{
          general: { embedded: true },
          header: { title: "Joker Bot", buttons: [Button.CLOSE_CHAT_BUTTON] },
          chatHistory: { storageKey: "example_smart_conversation" },
        }}
        flow={flow}
      />
      <div style={{ flex: 1, display: "flex", gap: "10px" }}>
        <CustomButton
          type={ButtonType.Submit}
          text="Start New Chat"
          onClick={changeThread}
        />
        <CustomButton
          type={ButtonType.Submit}
          text="Open Customer Service Simulator"
          onClick={() => window.open("/customer-service")}
        />
      </div>
    </>
  );
};

export default MyChatBot;
